import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaLinkedin,
  FaSpotify,
} from 'react-icons/fa';

const Footer = () => {
  const versionNumber = process.env.REACT_APP_VERSION;

  return (
    <footer className="bg-affidea-mid-blue text-white px-0 pt-0 pb-6 font-primary max-w-full">
      <div className="lg:p-14 ">
        <div className=" grid grid-cols-12 gap-4 p-12">
          {/* Left Section - Affidea Info */}
          <div className="col-span-12 md:col-span-6">
            <div className="text-lg/4 font-semibold mb-3">Affidea</div>
            <div className="text-[12.8px] font-extrabold text-affidea-blue-text mb-3.5">
              UAB Affidea Lietuva
            </div>

            <div className="mt-2 text-[12.8px] font-normal text-affidea-blue-text">
              <p>Įmonės kodas 300542299</p>
              <p>PVM mokėtojo kodas LT100007270812</p>
              <p>Savanorių pr. 184, LT-44150 Kaunas</p>
              <p> +370 521 99 513 (šiuo numeriu pacientai neregistruojami)</p>
              <p>
                <a href="mailto:info@affidea.lt" className="hover:text-white">
                  info@affidea.lt
                </a>
              </p>
              <p className="font-semibold">Turite klausimų?</p>
              <p>
                Informacija apie paslaugas:&nbsp;
                <a
                  href="mailto:pacientams@affidea.com"
                  className="hover:text-white"
                >
                  pacientams@affidea.com
                </a>
              </p>
              <p>
                Tel. <span className="font-bold">1811</span> arba{' '}
                <span className="font-bold">+370 524 411 88</span>
              </p>
              <p>
                Paslaugų kokybė:&nbsp;
                <a href="mailto:kokybe@affidea.com" className="hover:text-white">
                  kokybe@affidea.com
                </a>
              </p>
              <p>
                Asmens duomenys:&nbsp;
                <a
                  href="mailto:duomenusauga@affidea.com"
                  className="hover:text-white"
                >
                  duomenusauga@affidea.com
                </a>
              </p>
              <p>
                <a
                  href="http://affidea.lt"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white visited:text-white"
                >
                  affidea.lt
                </a>
              </p>
            </div>

            {/* Social Media Icons */}
            <div className="flex justify-start gap-2 mt-6">
              <span className="bg-white rounded-full w-10 h-10 min-w-10 min-h-10 flex items-center justify-center">
                <a
                  href="https://www.facebook.com/affidealt"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="text-[rgb(81,128,202)]"
                >
                  <FaFacebook size={18} />
                </a>
              </span>
              <span className="bg-white rounded-full w-10 h-10 min-w-10 min-h-10 flex items-center justify-center">
                <a
                  href="https://www.instagram.com/affidea_lietuva/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="text-[rgb(81,128,202)]"
                >
                  <FaInstagram size={18} />
                </a>
              </span>
              <span className="bg-white rounded-full w-10 h-10 min-w-10 min-h-10 flex items-center justify-center">
                <a
                  href="https://www.youtube.com/@affidealietuva9919"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Youtube"
                  className="text-[rgb(81,128,202)]"
                >
                  <FaYoutube size={18} />
                </a>
              </span>
              <span className="bg-white rounded-full w-10 h-10 min-w-10 min-h-10 flex items-center justify-center">
                <a
                  href="https://www.linkedin.com/company/affidea-lietuva/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  className="text-[rgb(81,128,202)]"
                >
                  <FaLinkedin size={18} />
                </a>
              </span>
              <span className="bg-white rounded-full w-10 h-10 min-w-10 min-h-10 flex items-center justify-center">
                <a
                  href="https://open.spotify.com/show/4FsEh3kcPmpjeNBco8BGOb"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Spotify"
                  className="text-affidea-dark-blue"
                >
                  <FaSpotify size={18} />
                </a>
              </span>
            </div>
          </div>

          {/* Right Section - Svarbiausi Dokumentai */}
          <div className="col-span-12 md:col-span-6">
            <h3 className="text-lg/4 font-semibold mb-3">
              Svarbiausi dokumentai
            </h3>
            <ul className="space-y-2 text-[12.8px]  text-affidea-blue-text">
              <li>
                <a href="https://affidea.lt/lt/imones-politikos/" className="hover:text-white visited:text-white">
                  Įmonės politikos
                </a>
              </li>
              <li>
                <a href="https://affidea.lt/lt/duomenu-apsauga/" className="hover:text-white visited:text-white">
                  Duomenų apsauga
                </a>
              </li>
              <li>
                <a href="https://mano.affidea.lt/static/media/Slapuku_privatumo_pranesimas_V1.9a76ee687cf7c000682e.pdf" className="hover:text-white visited:text-white">
                  Slapukų politika
                </a>
              </li>
              <li>
                <a
                  href="https://affidea.lt/lt/svetaines-privatumo-pranesimas/"
                  className="hover:text-white visited:text-white"
                >
                  Svetainės privatumo politika
                </a>
              </li>
              <li>
                <a
                  href="https://affidea.lt/lt/informacija-apie-laukimo-eiles/"
                  className="hover:text-white visited:text-white"
                >
                  Informacija apie laukimo eiles
                </a>
              </li>
              <li>
                <a
                  href="https://affidea.lt/lt/svarbiausi-dokumentai-pagal-klinikas/"
                  className="hover:text-white visited:text-white"
                >
                  Informacija pacientams
                </a>
              </li>
              <li>
                <a
                  href="https://storage.googleapis.com/afffideaglobal/SOP_LC_LT_042_Portalo_mano_affidea_lt_naudojimo_taisykles_v1_1_1_e73d9925cb/SOP_LC_LT_042_Portalo_mano_affidea_lt_naudojimo_taisykles_v1_1_1_e73d9925cb.pdf"
                  className="hover:text-white visited:text-white"
                >
                  Naudojimosi taisyklės
                </a>
              </li>
              <li className='text-base text-white'>
                  {versionNumber}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
